/**
 * Leads Module Configuration
 *
 * Captures, scores, and coalesces prospective leads from public web forms,
 * severe weather swaths, and marketing campaigns, supporting Acumatica ERP synchronization.
 *
 * @see docs/ACUMATICA-INTEGRATION-2.md
 */

import type { AppModule } from '@/types/architecture'
import routes from './routes'

const leadsModule: AppModule = {
    id: 'leads',

    navigation: {
        label: 'Leads',
        icon: 'target',
        path: '/leads',
        order: 15,
        moduleKey: 'leads',

        pages: [
            {
                label: 'All Leads',
                path: '/leads',
            },
            {
                label: 'Add Lead',
                path: '/leads/create',
                icon: 'user-plus',
                minAccessLevel: 'standard',
            },
        ],
    },

    routes,
}

export default leadsModule

// Export public components, services, and types
export { default as LeadCaptureForm } from './components/LeadCaptureForm.vue'
export { default as LeadConvertModal } from './components/LeadConvertModal.vue'
export { default as LeadDisqualifyModal } from './components/LeadDisqualifyModal.vue'
export { default as LeadAddLinkModal } from './components/LeadAddLinkModal.vue'
export { default as LeadEditModal } from './components/LeadEditModal.vue'
export { leadService } from './api/service'
export * from './api/types'
